import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { NextButton } from '../../stateless/buttons';
import { AnswersMatrixTextRadio } from '../../stateless/answers';
import HOCNextStepController from '../../hoc/next-step-controller';
import ReviewResults from '../../shared/review-results';

const EnhancedButton = HOCNextStepController(NextButton);

export default class EconomicalMatrix extends Component {

	static PropTypes = {
		user: PropTypes.object,
		window: PropTypes.object,
		players: PropTypes.object,
		nextWindow: PropTypes.func,
		updateAnswer: PropTypes.func,
		currentValue: PropTypes.string,
		countryCode: PropTypes.string
	};

	componentWillReceiveProps (nextProps) {
		if (this.props.currentValue !== nextProps.currentValue) {
			this.calculateResult(nextProps);
		}
	}

	calculateResult (newProps) {
		let newState = {};
		const { currentValue } = newProps;
		const { answers } = newProps.window.current;
		const answer = answers.find(ans => ans.value === currentValue);
		const { resources, playerBaseResources } = answer;

		for (let [key] of Object.entries(newProps.players)) {
			newState[key] = {resources: (playerBaseResources && playerBaseResources[key]) || 0};
		}

		for (let [player, rewardValue] of Object.entries(resources)) {
			newState[player].resources = rewardValue;
		}

		this.props.updateSaveState({ players: newState });
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const {user, countryCode, players, window, updateAnswer, currentValue} = this.props;
		return (
			<div>
				<Copy user={user} window={window} countryCode={countryCode} players={players}>

					{
						(window.current && window.current.reviewResults) &&
						<ReviewResults />
					}

					{
						window.current.answers &&
						<AnswersMatrixTextRadio
							answers={window.current.answers}
							updateAnswer={updateAnswer}
							currentValue={currentValue}
							countryCode={countryCode}
						/>
					}
					<EnhancedButton
						{ ...this.props }
						hasResources={ true }
					/>
				</Copy>
			</div>
		)
	}
}
